import { styled } from '@mui/material'
import MuiCardHeader from '@mui/material/CardHeader'
import { CardHeaderProps } from './CardHeader.types'

export const CardHeader = styled(MuiCardHeader)<CardHeaderProps>`
  padding: ${({ theme, spacing }) => theme.spacing(spacing ?? 0)};
  border-bottom: thin solid rgba(0, 0, 0, 12%);
`
